<template>
    <div :class="mysnackbar.modal ? 'snackbar-overlay show ' + mysnackbar.type : 'snackbar-overlay hide'">
        <div class="snackbar-container">
            <p>{{ mysnackbar.message }}</p>
            <span class="close" @click="closeModal()">X</span>
        </div>
    </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex';
import {setTimeout} from 'timers';

export default {
    data() {
        return {};
    },
    computed: {
        mysnackbar: {
            set(val) {
                return val;
            },
            get() {
                return this.obj;
            }
        },
        ...mapGetters('snackbar', ['obj'])
    },
    watch: {
        snackbar(val) {
            if (val.modal == true) {
                const self = this;
                setTimeout(() => {
                    self.closeModal();
                }, val.time);
            }
        }
    },
    mounted() {
        if (this.snackbar.modal == true) {
            this.closeModal();
        }
    },
    methods: {
        closeModal() {
            this.va_closeSnackbar();
        },
        ...mapActions({
            va_closeSnackbar: 'snackbar/closeSnackbar'
        })
    }
};
</script>

<style scoped>
.snackbar-overlay {
    position: fixed;
    right: 0px;
    left: 0px;
    bottom: -100%;
    margin: 0 auto;
    width: 320px;
    border-radius: 7px;
    padding: 15px 16px;
    transition: 0.4s ease-in-out;
    -moz-transition: 0.4s ease-in-out;
    -webkit-transition: 0.4s ease-in-out;
    z-index: 9999;
}
.snackbar-overlay.hide {
    bottom: -100%;
    transition: 0.4s ease-in-out;
    -moz-transition: 0.4s ease-in-out;
    -webkit-transition: 0.4s ease-in-out;
}
.snackbar-overlay.show {
    bottom: 10px;
    transition: 0.4s ease-in-out;
    -moz-transition: 0.4s ease-in-out;
    -webkit-transition: 0.4s ease-in-out;
}

.snackbar-overlay.success {
    background: #43d284;
}
.snackbar-overlay.warning {
    background: red;
}
.snackbar-overlay.default {
    background: #8e8e8e;
}
.snackbar-overlay p {
    color: #fff;
    font-size: 13px;
    font-weight: 600;
    margin-bottom: 0px;
    text-transform: capitalize;
}
.snackbar-container {
    display: flex;
    flex-direction: column;
    padding-right: 40px;
    position: relative;
}
.snackbar-container .close {
    color: #fff;
    background: #000;
    font-size: 11px;
    border-radius: 50%;
    padding: 4px 8px;
    position: absolute;
    right: 6px;
    top: 50%;
    font-weight: 600;
    cursor: pointer;
    transform: translatey(-50%);
}
.snackbar-container .close:hover {
    opacity: 0.8;
}
@media only screen and (min-width: 1367px) {
    .snackbar-overlay {
        width: 400px;
    }
}
@media only screen and (max-width: 991px) {
    .snackbar-overlay {
        width: 400px;
    }
}
@media only screen and (max-width: 768px) {
    .snackbar-overlay {
        width: 320px;
    }
}
</style>
